import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IAlarm } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { alarmColumns } from "./components/alarmColumns";
import { alarmSearchFields } from "./components/alarmSearchFields";

export const AlarmList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IAlarm>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }],
            },
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="사용자에게 발송된 푸시알림 내역"
            />

            <SearchToolbar
                fields={alarmSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={alarmColumns}
                getRowShowPath={(row) => `/alarms/show/${row.id}`}
                isError={tableQueryResult.isError}
                errorMessage="알림 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 알림이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
            />
        </List>
    );
};
